const TimelineData = [
  {
    id: 'education',
    date: '2019 - 2023',
    shortDate: '2019',
    role: 'Bachelors in Electrical Engineering',
    company: 'Punjab Engineering College (PEC)',
    location: 'Chandigarh, India',
    details: [
      'Graduated with 7.65 CGPA.',
      'Developed Placed.PEC (College Recruitment Platform) using React.js, Firebase, Firestore, and Bootstrap.',
      'Won 1st Prize (out of 1,100) in Code Rush 1.0 intra-college coding competition.'
    ]
  },
  {
    id: 'nucleus',
    date: 'Jan 2022 - July 2022',
    shortDate: 'Jan 2022',
    role: 'DevOps Intern',
    company: 'Nucleus Software Exports',
    location: 'Noida, India',
    details: [
      'Led a code migration POC from SVN to Git based VCS (GitLab) and automated 60+ user acceptance test scenarios using FitNesse. Built and deployed secure, configurable immutable infrastructure with CI/CD automation, reducing manual errors by 40% and achieving a 50% faster feedback loop.'
    ]
  },
  {
    id: 'skeps',
    date: 'July 2023 - July 2025',
    shortDate: 'July 2023',
    role: 'Software Development Engineer',
    company: 'Skeps',
    location: 'Gurugram, India',
    details: [
      'Engineered high-performance RESTful APIs with Node.js/Express, cutting response times by 30%, and architected a distributed data warehouse microservice with custom ETL capabilities that reduced analysis workloads by 40% and costs by 25%. Honored with the SPOT Award for automating critical workflows to boost operational efficiency.'
    ]
  },
  {
    id: 'zupee',
    date: 'July 2025 - March 2026',
    shortDate: 'July 2025',
    role: 'Software Engineer',
    company: 'Zupee',
    location: 'Gurugram, India',
    details: [
      'Delivered Zupee Studio within 1 week and migrated 1.5M user records seamlessly using AWS Lambda, S3, and SQS. Optimized system performance with a multi-cache wrapper boosting API latency by 65%, introduced a chaos testing framework, and improved payment success metrics through A/B gateway routing. Earned the Hustler Award for high-impact deliverables.'
    ]
  },
  {
    id: 'alaan',
    date: 'April 2026 - Present',
    shortDate: 'April 2026',
    role: 'Senior Software Engineer',
    company: 'Alaan',
    location: 'Bengaluru, India',
    details: [
      'Spearheaded the extraction of a NestJS microservice from a monolithic codebase, optimizing core workflows and cutting API latency by 60%, while resolving critical security vulnerabilities across application services.'
    ]
  }
];

export default TimelineData;
